import { hasActionPermission } from "@/utils/auth";

function resolveRequiredActions(binding) {
  const { value } = binding;
  if (Array.isArray(value)) {
    return value.filter((item) => typeof item === "string" && item);
  }
  if (typeof value === "string" && value) {
    return [value];
  }
  return [];
}

function removeElement(el) {
  const parent = el && el.parentNode;
  if (parent) {
    parent.removeChild(el);
  }
}

function checkPermission(el, binding) {
  const required = resolveRequiredActions(binding);
  if (!required.length) {
    return;
  }
  const granted = required.some((action) => hasActionPermission(action));
  if (!granted) {
    removeElement(el);
  }
}

export default {
  inserted(el, binding) {
    checkPermission(el, binding);
  },
  update(el, binding) {
    checkPermission(el, binding);
  },
};
